import React from "react";
import PropTypes from "prop-types";

/** Shared upper-filter shell (same visual as MetadataFilterToolbar / wrong-number.jsx). */
const LegacyFilterToolbar = ({ children, className = "" }) => (
  <div
    className={`metadata-filter-toolbar upper-filter-bar manage-user-filter-strip ${className}`.trim()}
  >
    {children}
  </div>
);

LegacyFilterToolbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export const LEGACY_FILTER_INPUT_CLASS = "border w-100 category-search-input";

export { default as UpperFilterFieldCol } from "components/Common/UpperFilterFieldCol";
export {
  buildUpperFilterFieldColClassName,
  isMetadataFilterValueActive,
} from "helpers/metadataFilterHelpers";

export default LegacyFilterToolbar;
